import React, { useEffect, useState } from 'react';
import { Button, Form, message } from 'antd';

import StAddNew from './DSeries/StAddNew';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';

const ApiTest = ({
    setPageHeader
}) => {
    const [form] = Form.useForm();
    const [responseData, setResponseData] = useState();
    const [loading, setLoading] = useState();
    useEffect(() => {
        if (setPageHeader) {
            setPageHeader("ApiTest");
        }
    }, []);

    const testApi = async (values) => {
        setResponseData(null);
        setLoading(true);
        let { method, api, payload } = values;
        try {
            let response;
            if (method === 'GET') {
                response = await liracrypt.get(api, JSON.parse(payload));
            }
            if (values.method === 'POST') {
                response = await liracrypt.post(api, JSON.parse(payload));
            }
            if (values.method === 'PATCH') {
                response = await liracrypt.patch(api, JSON.parse(payload));
            }
            if (values.method === 'DELETE') {
                response = await liracrypt.delete(api, JSON.parse(payload));
            }
            message.success('Successfull');
            setResponseData(response.data);
            // if (response.data.isSuccess) {
            //     message.success('Successfull');
            //     setResponseData(response.data);
            // }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            ApiErrorComp();
            if (err?.response?.data) {
                setResponseData(err?.response?.data);
            }

        }

    }

    return (
        <div>
            <StAddNew
                urlMethod={"GET"}
                formName="ApiTestForm"
                //  setSmodalTitle={title => { setModalTitle(title) }}
                initForm={form}
                colSpan={12}
                urlEndpoint={'/miscellaneous/pageconfig'}
                urlData={{ dictName: 'ApiTesting' }}
                // dictName={currentStep?.smodal?.dictName}
                //  pageName={currentStep?.smodal?.pageName}
                onFormSubmit={testApi}
            />
            <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                <Button loading={loading} size='large' htmlType='submit' type="primary" form={'ApiTestForm'}>Submit</Button>
            </div>
            {
                responseData && (
                    <div style={{ overflowY: 'auto', marginTop: 20, maxWidth: 'calc(100% - 70px)', maxHeight: 600, border: '1px solid #ffffff', borderRadius: 10, padding: 10 }}>
                        <div className='copy-text-btn-container'>
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigator.clipboard.writeText(JSON.stringify(responseData, null, 2)).then(() => {
                                        message.success('Copied Successfully');
                                    })
                                }}>Click To Copy</Button>
                        </div>
                        <p style={{ color: 'white' }}><pre>{JSON.stringify(responseData, null, 2)}</pre></p>
                    </div>
                )
            }
        </div>
    )
};

export default ApiTest;